module.exports = __webpack_public_path__ + "img/cloud_mgm.68f64c3c.png";